import { RequestStatus } from 'features/request/requestSlice';
import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useMemo } from 'react';

import { createWorkOrderChange } from '../WorkOrderChangeQueries';

export const useCreateWorkOrderChange = () => {
    const [createWorkOrderChangeData, createWorkOrderStatus, createWorkOrderErr, createWorkOrderRequest] = useRequest({
        requestId: 'createWorkOrderChange',
        query: createWorkOrderChange,
        withEffect: false,
    });

    const [resetCreatingData] = useResetStoreData({ requestId: 'createWorkOrderChange' });

    const isCreatingInProgress = useMemo(
        () => createWorkOrderStatus === RequestStatus.FETCHING,
        [createWorkOrderStatus],
    );

    return {
        creatingData: createWorkOrderChangeData?.uerCreateWorkOrderChange,
        creatingStatus: createWorkOrderStatus,
        creatingErr: createWorkOrderErr,
        creatingRequest: createWorkOrderRequest,
        resetCreatingData,
        isCreatingInProgress,
    };
};
